import { render, staticRenderFns } from "./ydinr.vue?vue&type=template&id=fc4f17c0&scoped=true"
import script from "./ydinr.vue?vue&type=script&lang=js"
export * from "./ydinr.vue?vue&type=script&lang=js"
import style0 from "./ydinr.vue?vue&type=style&index=0&id=fc4f17c0&prod&lang=css"
import style1 from "./ydinr.vue?vue&type=style&index=1&id=fc4f17c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4f17c0",
  null
  
)

export default component.exports